import React from "react";
import "../styles/ServiceCategories.css";

const ServiceCategories = () => {
  const categories = [
    {
      id: 1,
      title: "SKINCARE",
      image: "https://customer-assets.emergentagent.com/job_aura-aesthetics-2/artifacts/qqs9whov_model3.jpeg",
      link: "#services"
    },
    {
      id: 2,
      title: "IV INFUSIONS",
      image: "https://images.pexels.com/photos/7446676/pexels-photo-7446676.jpeg?auto=compress&cs=tinysrgb&w=800",
      link: "#services"
    },
    {
      id: 3,
      title: "ANTI-WRINKLE",
      image: "https://images.pexels.com/photos/36497923/pexels-photo-36497923.jpeg?auto=compress&cs=tinysrgb&w=1200",
      link: "#services"
    },
    {
      id: 4,
      title: "FAT DISSOLVING",
      image: "https://customer-assets.emergentagent.com/job_aura-aesthetics-2/artifacts/ec3gadpv_Designer%20%283%29.jpeg",
      link: "#services"
    }
  ];

  const scrollToServices = () => {
    const element = document.getElementById("services");
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <section className="service-categories-section">
      <div className="service-categories-grid">
        {categories.map((category) => (
          <div
            key={category.id}
            className="category-card"
            onClick={scrollToServices}
          >
            <div className="category-image">
              <img src={category.image} alt={category.title} />
              <div className="category-overlay"></div>
            </div>
            <div className="category-content">
              <h3 className="category-title">{category.title}</h3>
              <button className="category-btn">CLICK HERE</button>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default ServiceCategories;
